<template>
  <div v-if="critereRecherche" class="tableWithPerPageSelection">
    <div class="entete border-entete"  v-if="!isListeFacturesClient">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeFactures.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <dropdown-button
              type="is-addOrEdit"
              :permission="permFactures.maj"
              :actions="actionsButton"
              @click="() => $router.push({name: 'm.bodac.factures'})">
                {{ $t('listeFactures.actions.newQuotation')}}
            </dropdown-button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                          :error="error"
                          :title="'listeFactures.error.problemOccurred'"
                          :withEmplyFields="true"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          @close="error = $event"/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow" v-if="!isListeFacturesClient">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllFactureSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column"
            :class="{'is-5': !isListeFacturesClient}">
            <b-input :placeholder="$t('listeFactures.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeFactures.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permFactures.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownloadExportPrelevement"></a>
    <a ref="lienDownload"></a>
    <a ref="lienDownloadExportExcel"></a>
    <v-server-table url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="this.factures">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props"
           class="has-text-centered">
        <b-checkbox v-model="props.row.selected"
                    :value="props.row">
        </b-checkbox>
      </div>
      <div slot="code" slot-scope="props">
        <router-link-blank
          v-if="isListeFacturesClient"
          :message="props.row.code"
          :to="{ name: 'c.bodac.factures', params: {id: props.row.id}}"
          :class="{'text-access-no-permission': !checkPermissions(permFactures.lecture)}"
          class="lien is-inline">
        </router-link-blank>
        <router-link
          v-else-if="!props.row.interne"
          :to="{ name: 'c.bodac.factures', params: {id: props.row.id}}"
          :class="{'text-access-no-permission': !checkPermissions(permFactures.lecture)}"
          class="lien is-inline">
          {{props.row.code}}
        </router-link>
        <router-link
          v-else
          :to="{ name: 'c.bodac.factures-venteInterne', params: {id: props.row.id}}"
          :class="{'text-access-no-permission': !checkPermissions(permFactures.lecture)}"
          class="lien is-inline">
          {{ props.row.code }}
        </router-link>
        <b-tooltip
          v-if="props.row.interne"
          type="is-primary"
          position="is-right"
          :label="$t('listeFactures.interne')">
          <b-icon
            icon="information"
            class="mgl-5px"
            size="is-small"
            type="is-primary">
          </b-icon>
        </b-tooltip>
        <send-facture-icon
          class="mgl-5px"
          :sendMail="checkFactureParEmail(props.row)" />
        <tag-list
              class="mgl-2 is-justify-content-flex-end is-inline-block is-pulled-right"
              v-if="getListeTags(props.row)"
              :listes="getListeTags(props.row)"/>
      </div>
      <div slot="codeDossier" slot-scope="props">
        {{props.row.codeDossier}}
      </div>
      <div slot="commercialId" slot-scope="props">
        {{props.row.nomCommercial}}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(props.row.etatLibelle) }}
      </div>
      <div slot="sousType" slot-scope="props">
        {{ $t(props.row.sousTypeLibelle) }}
      </div>
      <div slot="payeur" slot-scope="props">
        <router-link-blank
          :to="{ name: 'c.bodac.clients/contacts-client',
          params: { id: props.row.payeurId }}"
          :message="props.row.payeurLibelle">
        </router-link-blank>
      </div>
      <div slot="annonceur" slot-scope="props">
        <router-link-blank
          v-for="(annonceur, index) in props.row.annonceurs"
          :key="index"
          :to="{ name: 'c.bodac.clients/contacts-client',
          params: { id: annonceur.tiersId }}"
          :message="annonceur.nomCommercial">
        </router-link-blank>
      </div>
      <div slot="datePremierAffichage" slot-scope="props">
        {{props.row.datePremierAffichage | formatDate}}
      </div>
      <div slot="dateDevisCommande" slot-scope="props" v-if="props.row.dateDevisCommande">
        {{props.row.dateDevisCommande | formatDate}}
      </div>
      <div slot="montantHt" slot-scope="props" class="is-pulled-right">
        {{props.row.montantHt | formatDevise}}
      </div>
      <div slot="montantTtc" slot-scope="props" class="is-pulled-right">
        {{props.row.montantTtc | formatDevise}}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId)}}
      </div>
      <div slot="montantRegle" slot-scope="props" class="is-pulled-right">
        {{props.row.montantRegle | formatDevise}}
      </div>
      <div slot="planMedia" slot-scope="props">
        <router-link-blank
          v-if="props.row.planMediaId"
          :message="props.row.planMedia.code"
          :to="{
            name: 'c.presse.plan_media',
            params: {id: props.row.planMediaId}
          }"
          :class="{'text-access-no-permission': !checkPermissions(perms.planMedia.lecture)}"
          class="lien">
        </router-link-blank>
      </div>
      <div slot="regleFacturation" slot-scope="props">
        <router-link-blank
          v-if="props.row.regleFacturationId"
          :message="props.row.regleFacturation.code"
          :to="{
            name: 'c.presse.regle_facturation-detail',
            params: {id: props.row.regleFacturationId}
          }"
          :class="{'text-access-no-permission': !checkPermissions(perms.regleFacturation.lecture)}"
          class="lien">
        </router-link-blank>
      </div>
      <div slot="categorieVente" slot-scope="props">
        {{ $t(getLibelleCategorieVente(props.row.categorieVente)) }}
      </div>
      <div slot="references" slot-scope="props">
        <router-link-blank
          v-if="getReferencesCommandeFacture(props.row.references).length === 1"
          :message="getReferencesCommandeFacture(props.row.references)[0].code"
          :to="{
            name: 'c.bodac.commandes',
            params: {id: getReferencesCommandeFacture(props.row.references)[0].id}
          }"
          :class="{'text-access-no-permission': !checkPermissions(perms.commande.lecture)}"
          class="lien">
        </router-link-blank>
        <span v-if="getReferencesCommandeFacture(props.row.references).length > 1">
          {{ $t('listeFactures.commandesMultiple') }}
        </span>
      </div>
      <div slot="editer" slot-scope="props"
           class="has-text-centered">
        <btn-action-icon
          :tooltip-label="$t('general.button.edition')"
          :permission="permFactures.editer"
          @is-click="edition({ format: 'Pdf', typeDonnee: constantes.TYPE_EDITION_FACTURE },
            props.row.id)"
          icon="file-pdf-box">
        </btn-action-icon>
      </div>
      <div slot="modifier" slot-scope="props"
           class="has-text-centered">
        <router-link v-bind:to="getToParamObject(props.row)"
                     :class="{ 'disabled': props.row.etat !== brouillon
                        && props.row.etat !== enregistrer
                        && props.row.etat !== annuler
                        && props.row.etat !== constantes.ETAT_PAYE }">
          <b-icon
            icon="pencil-box-outline"
            :type="{ 'is-success': props.row.etat === brouillon
              || props.row.etat === enregistrer
              || props.row.etat === annuler
              || props.row.etat === constantes.ETAT_PAYE }"
            :class="{'text-access-no-permission' :
              !checkPermissions(permFactures.maj) && props.row.etat === brouillon}">
          </b-icon>
        </router-link>
      </div>
      <div slot="archive"
           class="has-text-centered">
        <a @click="checkPermissions(permFactures.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permFactures.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="supprimer" slot-scope="props"
           class="has-text-centered">
        <a @click="checkPermissions(permFactures.maj) ?
          annulerFacture(props.row) : showPopUp()" v-if="peutAnnulerFacture(props.row)">
          <b-icon
            :key="props.id"
            icon="close-circle"
            type="is-danger"
            :class="{'text-access-no-permission': !checkPermissions(permFactures.maj)}">
          </b-icon>
        </a>
        <a @click="checkPermissions(permFactures.supprimer) ?
          supprimerFacture(props.row) : showPopUp()" v-else
           :class="{ 'disabled': props.row.etat !== brouillon }">
          <b-icon
            :key="props.id"
            icon="delete-forever"
            :type="{ 'is-danger': props.row.etat === brouillon }"
            :class="{'text-access-no-permission' :
              !checkPermissions(permFactures.supprimer) && props.row.etat === brouillon}">
          </b-icon>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="isComponentSupprimerFacture"
             has-modal-card
             class="modal" @close="facturesASupp = []">
      <app-confirmation-suppression-commande
        :devisCommandes="facturesASupp" @rechargement='rechargementSuiteSuppression()'
        :type="type"/>
    </b-modal>
    <b-modal v-model="popUpAvoir" has-modal-card class="modal"
             width="30vw" >
      <app-pop-up-avoir v-if="factureAAnnuler"
                        :factureInformation="factureAAnnuler"
                        :id="factureAAnnuler.id" :code="factureAAnnuler.code"
                        :withLettrageLettre="checkEtatLettrageLettreAndEtatFacture(factureAAnnuler)"
                        :sousType="factureAAnnuler.sousType">
      </app-pop-up-avoir>
    </b-modal>
    <b-modal v-model="popUpErreur"
             has-modal-card
             @close="recherche()"
             class="modal">
      <popup-erreur
        :messHeader="$t('listeFactures.error.problemInMultiSave')"
        :messages="messagesErreur"
      />
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="choiceEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="popUpGenererEcriture" has-modal-card class="modal" width="400px">
      <pop-up-prevention v-if="actionSelect === ACTION_GENERATION_ECRITURE"
        :messHeader="$t('listeFactures.generationEcriture.title')"
        messFooter=""
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @no="closeGenererEcriture"
        @yes="generationEcriture"
      />
    </b-modal>
    <b-modal v-model="openPopUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('listeFactures.actions.titlePreventionSolder')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.appliquer')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        @yes="solderManuellement"
        @no="closePopupSolderManuellement">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopupMassCommercial" has-modal-card class="modal"
      v-if="!modulePresseActive">
      <pop-up-changement-commercial
        :elementsSelectionnes="getAllFactureSelected()"
        @onEditAllCommercialUpdated="updateMassCommercial"
        @close="openPopupMassCommercial = false">
      </pop-up-changement-commercial>
    </b-modal>
    <b-modal v-model="popUpMailEnMasse" has-modal-card class="modal" width="1250px">
      <pop-up-facture-mail-en-masse
        :factures="getAllFactureSelected()"
        @close="popUpMailEnMasse = false"/>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-facture ref="filtreListeFacture"
          @toggleFiltre="changeValueShowFiltreAndLockMenu()"
          @recherche="makeRechercheFilter()"
          :factureParEmail="true"
          :storeName="nameStore"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import * as devisConf from '@/configuration/devisConf';
import inProgress from '@/services/general/inProgress';
import confirmationSuppressionCommande from '@/components/devisCommandes/confirmationSuppressionCommande';
import popUpAvoir from '@/components/devisCommandes/detailDevisCommande/popUpAvoir';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { FACTURES, COMMANDES } from '@/configuration/permissionsBodacConf';
import { CATEGORIE_PRODUIT, TYPE_DONNEE_DIAPORAMA } from '@/configuration/catalogue/produitConf';
import { PLAN_MEDIA, REGLE_FACTURATION } from '@/configuration/presse/permissionsPresseConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import edition from '@/api/edition/index';
import { get as getProduit } from '@/api/produit/index';
import { get as getParution } from '@/api/presse/parution';
import messageErreur from '@/services/general/messageErreur';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import filtreListeFacture from '@/components/factures/filtreListeFacture';
import {
  LISTE_CHOICE_EDITION_FACTURE,
  ACTION_EXPORT_PRELEVEMENT,
  EXPORT_EXCEL_TYPE_FACTURE,
  ACTION_EXPORT_PRELEVEMENT_XLS,
  TYPE_EDITION_FACTURE,
  ACTION_SOLDER_MANUELLEMENT,
  EXPORT_EXCEL_TYPE_EXPORT_PRELEVEMENT,
  ACTION_GENERATION_ECRITURE,
  ACTION_ENVOI_MAIL_MASSE,
} from '@/configuration/facture/factureConf';
import {
  ACTION_DELETE,
  ACTION_MASS_EDITION,
  ACTION_SAVE,
  ACTION_MASS_CHANGER_COMMERCIAL,
} from '@/configuration/general/actionsConf';
import saveMultiFacture from '@/services/facture/saveMultiFactures';
import messageSuccess from '@/services/general/messageSucces';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { columnsSplice } from '@/services/general/columns';
import popupErreur from '@/components/general/popUpErreur';
import selecteurAction from '@/components/general/selecteurAction';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import TableItemsInView from '@/components/general/TableItemsInView';
import popUpEdition from '@/components/factures/p_edition';
import { LETTRE } from '@/configuration/lettrageConf';
import createStringToExportPrelevement from '@/services/facture/createStringToExportPrelevement';
import exportExcel from '@/api/exportExcel';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import { pSolderManuellement } from '@/api/facture/index';
import validationFacture from '@/services/facture/validation/validationSolderManuellement';
import validationExport from '@/services/facture/validation/validationExportPrelevement';
import popUpPrevention from '@/components/general/popUpPrevention';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import parametrageTable from '@/components/general/parametrageTable';
import dropdownButton from '@/components/general/button/dropdownButton';
import { LISTE_EXCLUSION_DCF } from '@/configuration/dcf/dcfConf';
import popUpChangementCommercial from '@/components/general/popUpChangementCommercial';
import BtnActionIcon from '@/components/general/btnActionIcon';
import {
  generateByFacture,
} from '@/api/compta/ifEcriture';
import {
  TYPE_VENTE,
} from '@/configuration/compta/ecritureConf';
import tagList from '@/components/general/tagList';
import { FACTURE_CLIENT_STORE_NAME } from '@/configuration/tiers/tiersConf';
import popUpFactureMailEnMasse from '@/components/factures/liste/popUpFactureMailEnMasse';
import sendFactureIcon from '@/components/devisCommandes/sendFactureIcon';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'l_Factures',
  props: {
    nameStore: {
      type: String,
      required: true,
    },
    referenceTable: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      popUpErreur: false,
      popUpAvoir: false,
      factureAAnnuler: null,
      isComponentSupprimerFacture: false,
      showFiltre: false,
      facturesASupp: [],
      type: devisConf.TYPE_FACTURE,
      brouillon: devisConf.ETAT_BROUILLON,
      accompte: devisConf.SOUS_TYPE_ACOMPTE,
      enregistrer: devisConf.ETAT_ENREGISTRE,
      normal: devisConf.SOUS_TYPE_NORMAL,
      annuler: devisConf.ETAT_ANNULER,
      permFactures: FACTURES,
      perms: {
        planMedia: PLAN_MEDIA,
        regleFacturation: REGLE_FACTURATION,
        commande: COMMANDES,
      },
      unsubscribeValue: null,
      messagesErreur: [],
      actions: [],
      sens: devisConf.SENS_VENTE,
      popUpEdition: false,
      popUpGenererEcriture: false,
      choiceEdition: LISTE_CHOICE_EDITION_FACTURE,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      constantes: {
        TYPE_EDITION_FACTURE,
        ETAT_PAYE: devisConf.ETAT_PAYE,
      },
      openPopUpPrevention: false,
      messagesPopup: [''],
      isErrorPopup: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      actionSelect: null,
      routeParution: null,
      mountedLoadingEnd: false,
      startArrayRendering: false,
      actionsButton: [{
        label: this.$t('listeFactures.actions.newCreditNote'),
        action: () => this.$router.push({ name: 'm.bodac.factures-avoir' }),
      }],
      resultPerPage: RESULTS_PER_PAGE,
      openPopupMassCommercial: false,
      ACTION_GENERATION_ECRITURE: ACTION_GENERATION_ECRITURE,
      popUpMailEnMasse: false,
      factureForMail: [],
    };
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },

  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setupCritere();
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.ibizaPartnerId.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.rendreObligatoireAssistantEtCommercialSurCommandeFacture.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
      ]);
      this.actions = this.getActions();
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.goFirstPageAndCheckChangement, this.recherche);
      this.mountedLoadingEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
  components: {
    BtnActionIcon,
    appPopUpAvoir: popUpAvoir,
    appConfirmationSuppressionCommande: confirmationSuppressionCommande,
    AppBreadcrumb,
    filtreListeFacture,
    popupErreur,
    selecteurAction,
    TableItemsInView,
    popUpEdition,
    popUpPrevention,
    routerLinkBlank,
    errorMsgComponent,
    tableFooterTotaux,
    parametrageTable,
    exportExcelButton,
    dropdownButton,
    popUpChangementCommercial,
    tagList,
    popUpFactureMailEnMasse,
    sendFactureIcon,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    critereRecherche: {
      get() {
        return this.$store.getters[`${this.nameStore}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/SET_CRITERE`, value);
      },
    },
    factures() {
      return this.$store.getters[`${this.nameStore}/factures`];
    },
    lastPayload() {
      return this.$store.getters[`${this.nameStore}/lastPayload`];
    },
    totalFactures() {
      return this.$store.getters[`${this.nameStore}/totalFactures`];
    },
    isIbiza() {
      if (this.parametresInterne(PARAMETRES_INTERNE_KEYS.ibizaPartnerId.key) === undefined) {
        return false;
      }
      if (this.parametresInterne(PARAMETRES_INTERNE_KEYS.ibizaPartnerId.key) === null) {
        return false;
      }
      if (this.parametresInterne(PARAMETRES_INTERNE_KEYS.ibizaPartnerId.key).length > 0) {
        return true;
      }
      return false;
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeFactures.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeFactures.title'), route: { name: 'l.bodac.factures' }, isActive: true },
      ];
    },
    iconSelectTotal() {
      if (this.allFactureSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = [
        'selected', 'code', 'dateDevisCommande', 'sousType', 'payeur', 'annonceur', 'commercialId',
        'planMedia', 'regleFacturation', 'categorieVente', 'references',
        'etat', 'datePremierAffichage', 'codeDossier', 'montantHt', 'montantTtc', 'montantRegle',
        'editer', 'modifier', 'archive', 'supprimer',
      ];
      if (this.agencesSelectionnees.length > 1) {
        columns.splice(columns.findIndex((column) => column === 'montantHt'), 0, 'agence');
      }
      if (!this.modulePresseActive) {
        columnsSplice(columns, 'regleFacturation');
        columnsSplice(columns, 'categorieVente');
        columnsSplice(columns, 'references');
      }
      if (!this.modulePlanMediaActive) {
        columnsSplice(columns, 'planMedia');
      }
      if (this.isListeFacturesClient) {
        columnsSplice(columns, 'modifier');
        columnsSplice(columns, 'archive');
        columnsSplice(columns, 'supprimer');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeFactures.table.code'),
          codeDossier: this.$i18n.t('listeFactures.table.folderCode'),
          dateDevisCommande: this.$i18n.t('listeFactures.table.date'),
          sousType: this.$i18n.t('listeFactures.table.type'),
          payeur: this.$i18n.t('listeFactures.table.payer'),
          annonceur: this.$i18n.t('listeFactures.table.advertiser'),
          commercialId: this.$i18n.t('listeFactures.table.commercial'),
          etat: this.$i18n.t('listeFactures.table.status'),
          montantHt: this.$i18n.t('listeFactures.table.amountHt'),
          montantTtc: this.$i18n.t('listeFactures.table.amountTtc'),
          montantRegle: this.$i18n.t('listeFactures.table.amountPaid'),
          agence: this.$i18n.t('listeFactures.table.agence'),
          datePremierAffichage: this.$i18n.t('listeFactures.table.datePremierAffichage'),
          planMedia: this.$i18n.t('listeFactures.table.planMedia'),
          regleFacturation: this.$i18n.t('listeFactures.table.regleFacturation'),
          categorieVente: this.$i18n.t('listeFactures.table.categorieVente'),
          references: this.$i18n.t('listeFactures.table.references'),
          modifier: '',
          archive: '',
          supprimer: '',
          editer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['dateDevisCommande', 'montantHt', 'montantTtc', 'datePremierAffichage', 'sousType', 'etat', 'code', 'codeDossier', 'commercialId'],
        columnsClasses: {
          archive: 'colonneSelected',
          supprimer: 'colonneSelected',
          modifier: 'colonneSelected',
          editer: 'colonneSelected',
          selected: 'colonneSelected',
        },
        requestFunction: ((data) => {
          data.exclusion = LISTE_EXCLUSION_DCF;
          return this.actionsLoadFactures(data);
        }),
      };
    },
    allFactureSelected() {
      return this.getAllFactureSelected().length === this.factures.length;
    },
    targetTotal() {
      return ['montantTtc', 'montantHt'];
    },
    nombreCritere() {
      const banCritere = ['dates', 'datesPremierAffichage', 'montantHt', 'montantTtc', 'interne', 'factureParEmail', 'sens', 'nePasRelancer'];
      let nombreCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.dates) {
        nombreCritere += this.critereRecherche.dates.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.dates.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.datesPremierAffichage) {
        nombreCritere += this.critereRecherche.datesPremierAffichage.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.datesPremierAffichage.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.montantHt) {
        nombreCritere += this.critereRecherche.montantHt.montantMin !== null ? 1 : 0;
        nombreCritere += this.critereRecherche.montantHt.montantMax !== null ? 1 : 0;
      }
      if (this.critereRecherche.montantTtc) {
        nombreCritere += this.critereRecherche.montantTtc.montantMin !== null ? 1 : 0;
        nombreCritere += this.critereRecherche.montantTtc.montantMax !== null ? 1 : 0;
      }
      nombreCritere += this.critereRecherche.interne !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.nePasRelancer !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.factureParEmail !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    validationEdition() {
      const agencesId = Array.from(new Set(
        this.getAllFactureSelected().map((facture) => { return facture.agenceId; }),
      ));
      const agences = this.agencesSelectionnees.filter(agence => agencesId.includes(agence.id));
      if (new Set(agences.map((agence) => { return agence.piedPageHtml; })).size <= 1) {
        return true;
      }
      return (new Set(
        this.getAllFactureSelected().map((facture) => { return facture.agenceId; }),
      )).size <= 1;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_TYPE_FACTURE,
        typeExport: '',
        filtres: transform(this.lastPayload),
      };
    },
    isListeFacturesClient() {
      return this.nameStore === FACTURE_CLIENT_STORE_NAME;
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    updateMassCommercial() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.recherche();
        this.openPopupMassCommercial = false;
        loadingComponent.close();
        messageSuccess(this.$i18n.t('general.popUpChangementCommercial.success'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    closeGenererEcriture() {
      this.popUpGenererEcriture = false;
    },
    async generationEcriture() {
      try {
        this.debutLoading();
        this.popUpGenererEcriture = false;
        const promises = [];
        const ids = this.getAllFactureSelected().map((facture => facture.id));

        ids.forEach(id => {
          promises.push(generateByFacture(id, TYPE_VENTE));
        });
        await Promise.all(promises);
        this.finLoading();
        this.selectAll();
        messageSuccess(this.$i18n.t('listeFactures.generationEcriture.success'));
      } catch (e) {
        this.finLoading();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async setupCritere() {
      const critere = cloneDeep(this.critereRecherche);
      await updateCritereWithParametreInterne(critere, this.user, this.$route.params.tiersId);
      if (this.$route.params.commandeId) {
        critere.commandeId = this.$route.params.commandeId;
      }
      if (this.$route.params.sens) {
        this.sens = this.$route.params.sens;
      }
      if (this.$route.params.referenceIds) {
        critere.referenceIds = this.$route.params.referenceIds.split('|');
      }
      if (this.$route.params.produitId) {
        const produit = (await getProduit(this.$route.params.produitId)).data.result;
        critere.produitsIds = [produit];
      }
      if (this.modulePresseActive && this.$route.params.parutionId) {
        if (!this.routeParution) {
          this.routeParution = (await getParution(this.$route.params.parutionId)).data.result;
        }
        critere.parutionsIds = [this.routeParution];
      }
      const secteurIdsCurrentUser = (await getSecteursIdByUser(COMMERCIAL)).map(e => e.id);
      if (secteurIdsCurrentUser.length) critere.secteurIds = secteurIdsCurrentUser;
      this.critereRecherche = critere;
    },
    getActions() {
      const actions = [
        { action: ACTION_SAVE, translation: 'listeFactures.actions.save' },
        { action: ACTION_DELETE, translation: 'listeFactures.actions.delete' },
        { action: ACTION_MASS_EDITION, translation: 'listeFactures.actions.edition' },
        { action: ACTION_SOLDER_MANUELLEMENT, translation: 'listeFactures.actions.solderManuellement' },
        { action: ACTION_GENERATION_ECRITURE, translation: 'listeFactures.actions.genererEcriture' },
        { action: ACTION_ENVOI_MAIL_MASSE, translation: 'listeFactures.actions.envoiMailMasse' },
      ];

      if (this.isIbiza) {
        actions.push({
          action: ACTION_EXPORT_PRELEVEMENT_XLS,
          translation: 'listeFactures.actions.prelevementXls',
        });
      } else {
        actions.push({
          action: ACTION_EXPORT_PRELEVEMENT,
          translation: 'listeFactures.actions.exportPrelevement',
        });
      }
      if (!this.modulePresseActive) {
        actions.push({
          action: ACTION_MASS_CHANGER_COMMERCIAL,
          translation: 'listeDevis.actions.changementCommercial',
        });
      }
      return actions;
    },
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const ids = id ? [id] : this.getAllFactureSelected().map((facture => facture.id));
        if (!id && !this.validationEdition) {
          this.errorEdition.messages.push({ message: 'listeFactures.error.editionMultiAgence' });
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        const response = await edition({
          ids: ids,
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: {
            ...(donnees.typeDonnee === TYPE_DONNEE_DIAPORAMA && { isCBA: true }),
            ...(donnees.parametresAdditionnels ?? {}),
          },
        });

        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationDevisCommande({ data: response },
            this.errorEdition.messages,
            null,
            devisConf.TYPE_FACTURE);
          validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
            this.errorEdition.messages, this.errorEdition.messagesChampsVide, translate);
          if (this.errorEdition.messages.length > 0
            && this.getAllFactureSelected().map((facture => facture.id)).length > 1) {
            const index = this.errorEdition.messages.findIndex((message) => {
              return message.message === 'validationFacture.noOrderLinkedToBill';
            });
            if (index !== -1) {
              this.errorEdition.messages[index].message = 'validationFacture.noOrdersLinkedToBill';
            }
          }
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async saveMultiFacture() {
      if (!this.checkPermissions(this.permFactures.maj)) {
        this.showPopUp();
      }
      const loadingComponent = this.$buefy.loading.open();
      const factureToSave = this.getAllFactureSelected();
      const rsltOfSave = await saveMultiFacture(factureToSave);
      loadingComponent.close();
      if (rsltOfSave.nbFactureSave) {
        messageSuccess(this.$i18n.t(
          'listeFactures.success.factureSave', { numberFacture: rsltOfSave.nbFactureSave },
        ));
      }
      if (rsltOfSave.errors.length > 0) {
        this.messagesErreur = rsltOfSave.errors;
        this.popUpErreur = true;
      }
      this.recherche();
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    async exportPrelevement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = this.getAllFactureSelected().map((facture) => facture.id);
        const stringToExport = await createStringToExportPrelevement(ids);
        const data = new Blob([stringToExport], { type: 'text/plain' });
        const link = this.$refs.lienDownloadExportPrelevement;
        link.href = window.URL.createObjectURL(data);
        link.download = this.$i18n.t('listeFactures.exportPrelevement.title');
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    handleAction(action) {
      this.actionSelect = action;
      switch (action) {
        case ACTION_SAVE:
          this.saveMultiFacture();
          break;
        case ACTION_DELETE:
          if (this.checkPermissions(this.permFactures.supprimer)) this.inProgress();
          else this.showPopUp();
          break;
        case ACTION_MASS_EDITION:
          if (this.checkPermissions(this.permFactures.editer)) {
            this.errorEdition.messages = [];
            this.errorEdition.haveError = false;
            this.popUpEdition = true;
          } else this.showPopUp();
          break;
        case ACTION_EXPORT_PRELEVEMENT:
          if (this.checkPermissions(this.permFactures.exporter)) this.exportPrelevement();
          else this.showPopUp();
          break;
        case ACTION_EXPORT_PRELEVEMENT_XLS:
          if (this.checkPermissions(this.permFactures.exporter)) this.exportPrelevementToExcel();
          else this.showPopUp();
          break;
        case ACTION_SOLDER_MANUELLEMENT:
          this.openPopUpPrevention = true;
          break;
        case ACTION_GENERATION_ECRITURE:
          if (this.checkPermissions(this.permFactures.editer)) {
            this.errorEdition.messages = [];
            this.errorEdition.haveError = false;
            this.popUpGenererEcriture = true;
          } else this.showPopUp();
          break;
        case ACTION_ENVOI_MAIL_MASSE:
          if (this.checkPermissions(this.permFactures.editer)) {
            this.popUpMailEnMasse = true;
          } else this.showPopUp();
          break;
        case ACTION_MASS_CHANGER_COMMERCIAL:
          if (this.checkPermissions(this.permFactures.maj)) this.openPopupMassCommercial = true;
          else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFactures.error.noActionSelect'));
          break;
      }
    },
    async solderManuellement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = this.getAllFactureSelected().map((facture => facture.id));
        await pSolderManuellement(ids);
        loadingComponent.close();
        this.openPopUpPrevention = false;
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.messagesPopup = [''];
          validationFacture(e.response, this.messagesPopup);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    closePopupSolderManuellement() {
      this.openPopUpPrevention = false;
      this.isErrorPopup = false;
      this.messagesPopup = [''];
    },
    async exportPrelevementToExcel() {
      this.error = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = this.getAllFactureSelected().map((facture) => facture.id);
        const params = {
          nomFichier: 'Prelevement',
          typeDonnee: EXPORT_EXCEL_TYPE_FACTURE,
          typeExport: EXPORT_EXCEL_TYPE_EXPORT_PRELEVEMENT,
          parametresAdditionnels: {
            ids: ids.join(';'),
          },
        };
        const response = await exportExcel(params);
        const link = this.$refs.lienDownloadExportExcel;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.messages.push({
          message: 'general.messages.error.excelError',
          parametres: {},
        });
        validationExport(response, this.messages);
        this.error = true;
        loadingComponent.close();
        throw e;
      }
    },
    actionsLoadFactures(data) {
      return this.$store.dispatch(`${this.nameStore}/loadFactures`, data);
    },
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeFacture.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    goFirstPageAndCheckChangement() {
      if (this.critereRecherche.agencesId.length === 0) return;
      const agencesId = [];
      this.critereRecherche.agencesId.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesId.push(id);
      });
      this.critereRecherche.agencesId = agencesId;
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    checkEtatLettrageLettreAndEtatFacture(facture) {
      if (!facture) return false;
      return (facture.echeancierPaiement.some((echeance) => {
        return echeance.etatLettrage === LETTRE;
      }) && facture.etat !== devisConf.ETAT_ANNULER);
    },
    peutAnnulerFacture(value) {
      return (value.sousType === this.accompte || value.sousType === this.normal)
        && (value.etat === this.enregistrer || this.checkEtatLettrageLettreAndEtatFacture(value));
    },
    rechargementSuiteSuppression() {
      this.isComponentSupprimerFacture = false;
      this.facturesASupp = [];
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    selectAll() {
      const select = !this.allFactureSelected;
      this.factures.forEach((el) => {
        el.selected = select;
      });
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getAllFactureSelected() {
      return this.factures.filter((el) => {
        return el.selected;
      });
    },
    suppressionSelection() {
      this.facturesASupp = this.getAllFactureSelected();
      this.isComponentSupprimerFacture = true;
    },
    supprimerFacture(factureASupp) {
      this.facturesASupp.push(factureASupp);
      this.isComponentSupprimerFacture = true;
    },
    annulerFacture(facture) {
      if (facture.sousType === devisConf.SOUS_TYPE_ACOMPTE) {
        this.inProgress();
      } else {
        this.factureAAnnuler = facture;
        this.popUpAvoir = true;
      }
    },
    async reinitialiser() {
      this.$refs.filtreListeFacture.deleteTiersId();
      await this.$refs.filtreListeFacture.viderCritere();
    },
    getLibelleCategorieVente(categorieVente) {
      const categorieFind = CATEGORIE_PRODUIT.find((categorie) => {
        return categorie.code === categorieVente;
      });
      return categorieFind ? categorieFind.libelle : '';
    },
    getReferencesCommandeFacture(references) {
      if (!Array.isArray(references)) return [];
      return references.filter(r => r.type === devisConf.TYPE_COMMANDE);
    },
    checkFactureParEmail(facture) {
      return facture.intervenants
        .find(i => i.payeur === true)?.tiers?.factureParMail;
    },
    getFactureSelected() {
      return this.factures.filter((facture) => {
        return facture.selected;
      });
    },
    getToParamObject(row) {
      const isBrouillon = row.etat === this.brouillon;
      const idKey = isBrouillon ? 'id' : 'idFacture';
      return {
        name: isBrouillon ? 'm.bodac.factures-edition' : 'm.bodac.factures-editionEcheancierPaiement',
        params: { [idKey]: row.id },
      };
    },
    getListeTags(row) {
      if (!row?.tags || row.tags.length === 0) return null;
      return row?.tags?.map(t => t.tag) ?? [];
    },
  },
};
</script>

<style>
  .colonneListeIntervenants {
    min-width: 7vw;
    max-width: 20vw;
  }
</style>
